export const concepts = [
  {
    id: "control",
    name: "Baseline placements",
    summary: "Reference layout: logo, timed banner, playlist ad and endcard.",
  },
  {
    id: "consolidation",
    name: "Fewer, larger ads",
    summary:
      "Keep only a larger banner and endcard. Fewer competing ads aim to make the offer harder to miss.",
  },
  {
    id: "earned",
    name: "Ads after the highlight",
    summary:
      "Wait until after the highlight to show ads, aiming to reach viewers when attention is highest.",
  },
  {
    id: "endcard",
    name: "No mid-clip banner",
    summary:
      "Remove the mid-clip banner and emphasize the end-of-clip offer, giving viewers eight seconds to act after the clip.",
  },
  {
    id: "native",
    name: "Playlist sponsor row",
    summary:
      "Put a sponsored row where viewers choose the next clip. The aim is more clicks as viewers’ eyes naturally flow to it.",
  },
];
export const getConcept = (id) =>
  concepts.find((c) => c.id === id) || concepts[2];
